// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Game Selection - Matching Dashboard Theme
   ============================================ */

.GameSelection_gameSelection__yAamu {
  border: 1px solid rgba(135, 206, 235, 0.3);
  border-radius: 0.375rem;
  padding: 0.75rem;
  max-height: 200px;
  overflow-y: auto;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.GameSelection_gameSelection__yAamu::-webkit-scrollbar {
  width: 6px;
}

.GameSelection_gameSelection__yAamu::-webkit-scrollbar-track {
  background: transparent;
}

.GameSelection_gameSelection__yAamu::-webkit-scrollbar-thumb {
  background: rgba(135, 206, 235, 0.3);
  border-radius: 3px;
}

.GameSelection_gameSelection__yAamu::-webkit-scrollbar-thumb:hover {
  background: rgba(135, 206, 235, 0.5);
}

.GameSelection_gameItem__6pC4P {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}

.GameSelection_gameItem__6pC4P:hover {
  background: rgba(135, 206, 235, 0.05);
}

.GameSelection_gameItem__6pC4P.GameSelection_disabled__hEhur {
  opacity: 0.5;
  cursor: not-allowed;
}

.GameSelection_checkbox__MfP06 {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #87ceeb;
  flex-shrink: 0;
}

.GameSelection_checkbox__MfP06:disabled {
  cursor: not-allowed;
}

.GameSelection_gameLabel__QGKzi {
  font-size: 0.875rem;
  color: #000000;
  -webkit-user-select: none;
          user-select: none;
}

@media (max-width: 768px) {
  .GameSelection_gameSelection__yAamu {
    max-height: 150px;
    padding: 0.5rem;
  }

  .GameSelection_gameItem__6pC4P {
    padding: 0.375rem;
  }

  .GameSelection_gameLabel__QGKzi {
    font-size: 0.8125rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/GameSelection.module.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":["/* ============================================\n   Game Selection - Matching Dashboard Theme\n   ============================================ */\n\n.gameSelection {\n  border: 1px solid rgba(135, 206, 235, 0.3);\n  border-radius: 0.375rem;\n  padding: 0.75rem;\n  max-height: 200px;\n  overflow-y: auto;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.gameSelection::-webkit-scrollbar {\n  width: 6px;\n}\n\n.gameSelection::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.gameSelection::-webkit-scrollbar-thumb {\n  background: rgba(135, 206, 235, 0.3);\n  border-radius: 3px;\n}\n\n.gameSelection::-webkit-scrollbar-thumb:hover {\n  background: rgba(135, 206, 235, 0.5);\n}\n\n.gameItem {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 0.25rem;\n  transition: all 0.2s ease;\n}\n\n.gameItem:hover {\n  background: rgba(135, 206, 235, 0.05);\n}\n\n.gameItem.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.checkbox {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: #87ceeb;\n  flex-shrink: 0;\n}\n\n.checkbox:disabled {\n  cursor: not-allowed;\n}\n\n.gameLabel {\n  font-size: 0.875rem;\n  color: #000000;\n  user-select: none;\n}\n\n@media (max-width: 768px) {\n  .gameSelection {\n    max-height: 150px;\n    padding: 0.5rem;\n  }\n\n  .gameItem {\n    padding: 0.375rem;\n  }\n\n  .gameLabel {\n    font-size: 0.8125rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gameSelection": `GameSelection_gameSelection__yAamu`,
	"gameItem": `GameSelection_gameItem__6pC4P`,
	"disabled": `GameSelection_disabled__hEhur`,
	"checkbox": `GameSelection_checkbox__MfP06`,
	"gameLabel": `GameSelection_gameLabel__QGKzi`
};
export default ___CSS_LOADER_EXPORT___;
